//https://gamigo.atlassian.net/wiki/spaces/WTT/pages/280494083/Google+Analytic+Events
export const GTM_CUSTOM_EVENTS = {
  CUSTOM_DATA: 'custom-data', //set data layer values
  USER_SIGNUP: 'user_signup',
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  USER_SOCIAL_LOGIN_FAILED: 'user_social_login_failed',
  USER_SOCIAL_SIGNUP_FAILED: 'user_social_signup_failed',

  GAME_SHARED: 'game_shared',
  FULLSCREEN_ICON_CLICK: 'fullscreen_icon_click',

  //will be mapped in GTM to Pageview
  VIRTUAL_PAGEVIEW: 'virtual_pageview',

  //Ecommerce Events
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',
  VIEW_ITEM: 'view_item',
  BEGIN_CHECKOUT: 'begin_checkout',

  // ATM tracked in the hosted checkout
  //PURCHASE_COMPLETE: 'purchase-complete',

  //MEMBERSHIP CUSTOM EVENTS
  WILD_SIGNUP_COMPLETE: 'wild_signup_complete',
  WILD_CANCELLATION_COMPLETE: 'wild_cancellation_complete',
  WILD_DISCOUNT_APPLIED: 'wild_discount_applied',
  WILD_DISCOUNT_VIEW: 'wild_discount_view',

  //TO BE IMPLEMENTED
  WEB_PLAY_START: 'web-play-start',

  GAME_TRIAL_DOWNLOAD_STARTED: 'game_trial_download_started',
  //FIGURE OUT GAME_ACTIVITY

  // PAYMENT_REMINDER
  PAYMENT_PAST_DUE_REMINDER_DISPLAYED: 'payment_past_due_reminder_displayed',
} as const;

export type GTMCustomEvent = keyof typeof GTM_CUSTOM_EVENTS;
